import {Component, computed, input, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatTooltipModule} from "@angular/material/tooltip"
import {ConditionalAmountGroupNode, PricingNode} from "@cm/pricing"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-amount-group",
    templateUrl: "./conditional-amount-group-node.component.html",
    styleUrls: ["./conditional-amount-group-node.component.scss", "../node-styles.scss"],
    imports: [FormsModule, MatTooltipModule],
})
export class ConditionalAmountGroupNodeComponent {
    readonly $node = input.required<PricingNode>({alias: "node"})

    readonly $amountGroupNode = computed<ConditionalAmountGroupNode | undefined>(() => {
        const node = this.$node()
        if (node instanceof ConditionalAmountGroupNode) return node
        else return undefined
    })

    readonly $description = computed<string>(() => {
        const node = this.$amountGroupNode()
        if (node === undefined) return ""
        return node.parameters.description.length > 0 ? node.parameters.description : "Amount group node"
    })
}
